import React from 'react';
import Modal from '../../common/Modal/Modal'; // Assuming a generic Modal component exists
import LocationSelector from '../../common/Forms/LocationSelector';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import ErrorMessage from '../../common/ErrorMessage/ErrorMessage';
import './AddActivityModal.css'; // We'll create this CSS file later

const AddActivityModal = ({ 
    isOpen, 
    onClose, 
    newActivity, 
    handleInputChange, 
    handleFileChange, 
    handleCountryChange, 
    handleStateChange, 
    handleRemoveImage, 
    handleAddActivity, 
    previewImages, 
    isLoading, 
    error, 
    message 
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Add New Activity">
            <form 
                className="form-container add-activity-modal__form"
                onSubmit={handleAddActivity}
            >
                {error && <ErrorMessage message={error} />}
                {message && <div className="success-message">{message}</div>}
                {isLoading && <LoadingSpinner />}
                
                <div className="form-group">
                    <label htmlFor="activityTitleModal" className="form-label">Title *</label>
                    <input
                        type="text"
                        id="activityTitleModal"
                        name="title"
                        className="form-input"
                        value={newActivity.title}
                        onChange={handleInputChange}
                        required
                        disabled={isLoading}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="activityDescriptionModal" className="form-label">Description</label>
                    <textarea
                        id="activityDescriptionModal"
                        name="description"
                        className="form-textarea"
                        value={newActivity.description}
                        onChange={handleInputChange}
                        required
                        disabled={isLoading}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="activityDateModal" className="form-label">Date</label>
                    <input
                        type="date"
                        id="activityDateModal"
                        name="date"
                        className="form-input"
                        value={newActivity.date}
                        onChange={handleInputChange}
                        required
                        disabled={isLoading}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Location</label>
                    <LocationSelector
                        countryCode={newActivity.country}
                        stateCode={newActivity.state}
                        city={newActivity.location}
                        onCountryChange={(code) => handleCountryChange({ target: { value: code }})}
                        onStateChange={(code) => handleStateChange({ target: { value: code }})}
                        onCityChange={(city) => handleInputChange({ target: { name: 'location', value: city }})}
                        required={true}
                    />
                </div>

                <div className="form-group add-activity-modal__image-upload-group">
                    <label className="form-label">Images (Up to 10)</label>
                    <input
                        type="file"
                        id="activityImagesModalInput"
                        accept="image/*"
                        multiple
                        onChange={handleFileChange}
                        className="form-file-input"
                        disabled={isLoading}
                    />
                    <label htmlFor="activityImagesModalInput" className="form-file-label add-activity-modal__image-upload-label">
                        <i className="fas fa-upload"></i> Choose Images
                    </label>
                    
                    {previewImages.length > 0 && (
                        <div className="form-file-preview add-activity-modal__image-previews">
                            {previewImages.map((preview, index) => (
                                <div key={index} className="add-activity-modal__preview-item">
                                    <img src={preview} alt={`Preview ${index + 1}`} className="add-activity-modal__preview-img"/>
                                    <button
                                        type="button"
                                        className="add-activity-modal__remove-image"
                                        onClick={() => handleRemoveImage(index)}
                                        disabled={isLoading}
                                    >
                                        &times;
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="form-actions">
                    <button 
                        type="button" 
                        onClick={onClose}
                        disabled={isLoading}
                        className="form-button"
                    >
                        Cancel
                    </button>
                    <button 
                        type="submit" 
                        disabled={isLoading}
                        className="form-submit"
                    >
                        {isLoading ? 'Processing...' : 'Add Activity'}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default AddActivityModal; 